import { getZonedDate } from '@eika-infrastruktur/date';
import selectTransferAccounts from '../../form/selectTransferAccounts';
import { RecurringTransferActionType } from './actions';
import { recurringTransferInitialState } from './state';
const recurringTransferReducer = (state, action) => {
    switch (action.type) {
        case RecurringTransferActionType.ACCOUNT_SELECTED:
            return selectTransferAccounts(state, action.payload);
        case RecurringTransferActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case RecurringTransferActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case RecurringTransferActionType.OWNTEXT:
            return {
                ...state,
                ownText: action.payload,
            };
        case RecurringTransferActionType.FIRST_PAYMENT_DATE:
            return {
                ...state,
                firstPaymentDate: getZonedDate(action.payload),
            };
        case RecurringTransferActionType.LAST_PAYMENT_DATE:
            return {
                ...state,
                lastPaymentDate: action.payload ? getZonedDate(action.payload) : undefined,
            };
        case RecurringTransferActionType.FIRST_BANKING_DATE:
            return {
                ...state,
                firstBankingDate: action.payload,
                firstPaymentDate: action.payload,
            };
        case RecurringTransferActionType.ONLY_BANKING_DATE:
            return {
                ...state,
                firstBankingDate: action.payload,
            };
        case RecurringTransferActionType.PAYMENT_INTERVAL:
            return {
                ...state,
                paymentInterval: action.payload,
            };
        case RecurringTransferActionType.RESET:
            return {
                ...recurringTransferInitialState,
                firstBankingDate: state.firstBankingDate,
                firstPaymentDate: state.firstBankingDate,
            };
        case RecurringTransferActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case RecurringTransferActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        case RecurringTransferActionType.SHOW_TO_ACCOUNTS:
            return {
                ...state,
                showToAccounts: true,
            };
        case RecurringTransferActionType.HIDE_TO_ACCOUNTS:
            return {
                ...state,
                showToAccounts: false,
            };
        default:
            return state;
    }
};
export default recurringTransferReducer;
//# sourceMappingURL=data:application/json;base64,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